(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["af2-article"]) return;
  try {
    
(() => {
  const init = () => {
    const preview = document.querySelector('[data-reading-title]');
    if (preview) document.title = preview.dataset.readingTitle;
    const progress = document.querySelector('[data-reading-progress]');
    const body = document.querySelector('[data-reading-body]');
    if (!progress || !body || progress.dataset.ready) return;
    progress.dataset.ready = 'true';
    let frame = 0;
    const update = () => {
      frame = 0;
      const box = body.getBoundingClientRect();
      const range = Math.max(1, box.height - innerHeight * .45);
      const value = Math.min(1, Math.max(0, (innerHeight * .2 - box.top) / range));
      progress.style.transform = `scaleX(${value})`;
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    window.addEventListener('scroll', schedule, {passive:true});
    window.addEventListener('resize', schedule, {passive:true});
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["af2-header"]) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('.af2-shop-menu').forEach(menu => {
    if (menu.dataset.menuReady) return;
    menu.dataset.menuReady = 'true';
    const summary = menu.querySelector('summary');
    const sync = () => summary.setAttribute('aria-expanded', String(menu.open));
    sync();
    menu.addEventListener('toggle', sync);
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape' && menu.open) {
        event.preventDefault();
        menu.open = false;
        summary.focus();
      }
    });
    menu.addEventListener('focusout', () => requestAnimationFrame(() => {
      if (!menu.contains(document.activeElement)) menu.open = false;
    }));
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('.af2-shop-menu[open]').forEach(menu => {
      if (!menu.contains(event.target) || event.target.closest('a')) menu.open = false;
    });
    if (event.target.closest('#af2-menu a')) document.getElementById('af2-menu')?.close();
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["af2-journal"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = () => document.querySelectorAll('[data-journal]').forEach(section => {
    if (section.dataset.journalReady) return;
    section.dataset.journalReady = 'true';
    const select = section.querySelector('[data-sport-filter]');
    if (!select) return;
    const cards = [...section.querySelectorAll('[data-guide-key]')];
    const count = section.querySelector('[data-guide-count]');
    section.querySelector('.af2-journal-filter').hidden = false;
    const apply = () => {
      let visible = 0;
      cards.forEach(card => { card.hidden = select.value !== 'all' && card.dataset.guideKey !== select.value; if (!card.hidden) visible++; });
      count.textContent = visible === 1 ? count.dataset.one : count.dataset.many.replace('[count]', String(visible));
    };
    select.addEventListener('change', apply);
    apply();
  });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true}); else init();
})();

  } catch(e) { console.error(e); }
})();
})();
